import { render, staticRenderFns } from "./vReviewGroups.vue?vue&type=template&id=1853fe21&scoped=true"
import script from "./vReviewGroups.vue?vue&type=script&lang=js"
export * from "./vReviewGroups.vue?vue&type=script&lang=js"
import style0 from "./vReviewGroups.vue?vue&type=style&index=0&id=1853fe21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853fe21",
  null
  
)

export default component.exports